export const query_tenant_byId = `
query getTenantById($tenantId: String!) {
  tenant(where: { TenantId: {_eq: $tenantId}}, order_by: {StatusDate: desc}) {
    TenantId
    OwnerId
    Name
    Identifier
    IsReadOnly
    IsDisabled
    IsDeleted
    StatusDate
    VatNumber
    AddrStreetName
    AddrStreetNumber
    AddrCity
    AddrProvince
    AddrZipCode
    AddrCountry
    AddrFull
    Classifier
  }
}`;